export var ANALYTICS_CHANNEL = 'media';
export var COMPONENT_NAME = 'linkCreate';
export var SCREEN_ID = 'linkCreateScreen';
export var DEFAULT_TEST_ID = 'link-create';
export var CREATE_FORM_MAX_WIDTH_IN_PX = '480';
export var CREATE_FORM_MIN_HEIGHT_IN_PX = '200';
export var LINK_CREATE_FORM_POST_CREATE_FIELD = '__post_create__';
export var PACKAGE_DATA = {
  packageName: "@atlaskit/link-create" || '',
  packageVersion: "2.13.8" || '',
  component: COMPONENT_NAME,
  componentName: COMPONENT_NAME
};